import React, { useEffect, useState } from 'react'
import GetDiagnosisData from '../../services/general/getDiagnosisData.api'
import { CButton } from '@coreui/react'
import { useIndexedDB } from '../../context/IndexedContext'

const ProviderRiskFactors = ({ diagnosisName, noteStructureRef,loggedUserProvider,patientID,changesInTreatmentShell, setChangesInTreatmentShell ,noteCallType,setSelectedRisks,selectedRisks }) => {
  const [selectedRisksinComp, setSelectedRisksInComp] = useState([])
  const [allRisks, setAllRisks] = useState([])
  const {getOfflineData,saveOfflineData , getOpenChartOfflineData , saveOpenChartOfflineData } = useIndexedDB()

  useEffect(() => {
    const currentRiskString = noteStructureRef?.current?.riskFactors?.[diagnosisName] || ''
    const parsedArray = currentRiskString
      .split(',')
      .map(r => r.trim())
      .filter(Boolean)

    setSelectedRisksInComp(parsedArray)

    // Ensure the key exists
    if (!noteStructureRef.current.riskFactors) {
      noteStructureRef.current.riskFactors = {}
    }
  }, [diagnosisName, noteStructureRef])

  const { getRiskFactorMaster } = useIndexedDB()

  const getData = async () => {
    try {
      
      // const responseRisks = await GetDiagnosisData('Risks')
      // const localData = JSON.parse(responseRisks.d)?.Data || []

      const localData = await getRiskFactorMaster()
      console.log(localData,'localDatalocalDatalocalData')


      const fetchedRiskStr = localData.find(item => item.Name === diagnosisName)?.RiskFactors || ''
      const fetchedRiskArray = fetchedRiskStr.split(',').map(r => r.trim()).filter(Boolean)

      const storedRiskStr = noteStructureRef?.current?.riskFactors?.[diagnosisName] || ''
      const storedRiskArray = storedRiskStr.split(',').map(r => r.trim()).filter(Boolean)

      // Merge both and deduplicate using Set, then convert back to array
      const combined = [...new Set([...fetchedRiskArray, ...storedRiskArray])]
      setAllRisks(combined)
    } catch (error) {
      console.error('Error fetching risk factors:', error)
    }
  }

  useEffect(() => {
    getData()
  }, [diagnosisName, noteStructureRef])

      const handleAddToOfflineRiskFactor = async (modalText) => {
      let dataOffline = noteCallType === 'OpenChart' ? await getOpenChartOfflineData()  : await getOfflineData()
      if (dataOffline) {
        console.log('offlineData before adding alert data:', dataOffline);
        dataOffline = {
          ...dataOffline,
          [loggedUserProvider?.ID]: {
            ...dataOffline[loggedUserProvider?.ID],
            [patientID]: {
              ...dataOffline[loggedUserProvider?.ID][patientID],
              currentNote:{
                ...dataOffline[loggedUserProvider?.ID][patientID].currentNote,
                data: {
                  ...dataOffline[loggedUserProvider?.ID][patientID].currentNote.data,
                  riskFactors: {
                    ...dataOffline[loggedUserProvider?.ID][patientID].currentNote.data.riskFactors,
                    [diagnosisName]: modalText
                  }
                }
              },
              saveDraft : true
            }
          }
        }
      }
      console.log('offlineData after adding alert data:', dataOffline);
      noteCallType === 'OpenChart' ? await saveOpenChartOfflineData(dataOffline)  : await saveOfflineData(dataOffline)
    }

  const toggleRiskSelection = async(risk) => {
    let updated = [...selectedRisksinComp]
    if (updated.includes(risk)) {
      updated = updated.filter(item => item !== risk)
    } else {
      updated.push(risk)
    }
    setSelectedRisksInComp(updated)
    noteStructureRef.current.riskFactors[diagnosisName] = updated.join(',')
    await handleAddToOfflineRiskFactor(updated.join(','))
    setSelectedRisks((p)=>({
      ...p,
      [diagnosisName]:updated.join(',')
    }))
      setChangesInTreatmentShell((p) => !p)
  }

  console.log(allRisks,'allRisks')

  return (
    <div className="d-flex gap-2 flex-wrap">
      {allRisks.length > 0 ?
      allRisks.map((risk, idx) => (
        <CButton
          key={idx}
          variant="outline"
          color="secondary"  
          className="m-1 no-focus-outline"
          style={{
            color: selectedRisksinComp.includes(risk) ? 'white' : '#989898',
            border: selectedRisksinComp.includes(risk) ? '1px solid white' : '1px solid #989898',
            boxShadow: '',
          }}
          onClick={() => toggleRiskSelection(risk)}
        >
          {risk}
        </CButton>
        
      ))
      :
      <div className="d-flex justify-content-start align-items-start text-muted">
            <div
              style={{
                fontSize: '15px',
                fontWeight: '600px',
                color: 'gray',
              }}
            >
              No Risk Factors Found
            </div>
          </div>
    }
    </div>
  )
}

export default ProviderRiskFactors
